/**
 * GENERATED by bin/networks/emit-registry.mjs — do not edit. Run `yarn networks`.
 *
 * The shared network icon registry: one slug per network, spanning both pipelines.
 *
 *   · solid — a glyph in the `dlvr-networks` font (ui/src/css/dlvr-networks.css),
 *             monochrome and recoloured by CSS `color`.
 *   · color — original artwork under /dist/img, served as an <img>.
 *
 * Every slug has at least one of the two; neither is guaranteed on its own, so
 * render through <Networks> (ui/src/shadcn/components/ui/networks.tsx) rather than reading
 * these fields directly — it handles the fallback.
 */

export type NetworkSlug =
	| "blogger"
	| "bluesky"
	| "discord"
	| "ebay"
	| "etsy"
	| "facebook"
	| "facebook-groups"
	| "google-business"
	| "instagram"
	| "linkedin"
	| "mastodon"
	| "nextdoor"
	| "pinterest"
	| "reddit"
	| "rss"
	| "shopify"
	| "slack"
	| "snapchat"
	| "stocktwits"
	| "substack"
	| "threads"
	| "tiktok"
	| "tumblr"
	| "unsplash"
	| "vimeo"
	| "wordpress"
	| "x"
	| "youtube";

export type NetworkVariant = "solid" | "color" | "mark";

export interface NetworkEntry {
	/** Human-readable network name, for alt text and labels. */
	readonly label: string;
	/**
	 * Badge disc colour, matching `.dlvr-icon.<service>` in service-icons.styl so
	 * a brand disc looks the same here as everywhere else in the app.
	 */
	readonly brand: string;
	/**
	 * Set where `brand` is too light to carry a white glyph — WCAG 1.4.11 non-text
	 * contrast falls under 3:1. Verified by check-parity.mjs, not by eye.
	 */
	readonly ink?: "dark";
	/** Path under the asset base, or null where no colour artwork exists. */
	readonly color: string | null;
	/** Whether a glyph exists in the dlvr-networks font. */
	readonly solid: boolean;
	/**
	 * Horizontal wordmark rather than a square mark. Give it a wider box; scaling
	 * cannot square it up.
	 */
	readonly wordmark?: boolean;
	/**
	 * Full-colour artwork with NO badge disc, tight-cropped at its own aspect.
	 * A different treatment from `color` rather than a different encoding — pick
	 * whichever suits the surface. Null where no such artwork exists.
	 */
	readonly mark: string | null;
}

export const NETWORKS: Readonly<Record<NetworkSlug, NetworkEntry>> = {
	"blogger": { label: "Blogger", brand: "#F68F3E", color: "svg-outputs/blogger-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/blogger-icon-color.svg", solid: true }, // U+EA00
	"bluesky": { label: "Bluesky", brand: "#2860f6", color: "svg-outputs/bluesky-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/bluesky-icon-color.svg", solid: true }, // U+EA01
	"discord": { label: "Discord", brand: "#7289DA", color: "svg-outputs/discord-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/discord-icon-color.svg", solid: true }, // U+EA02
	"ebay": { label: "eBay", brand: "#E53238", color: "svg-logos/ebay.svg", mark: null, solid: false, wordmark: true }, // no solid: no square icon mark exists in any source
	"etsy": { label: "Etsy", brand: "#f46420", color: "svg-logos/etsy-color.svg", mark: null, solid: true }, // U+EA04
	"facebook": { label: "Facebook", brand: "#257CE1", color: "svg-outputs/facebook-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/facebook-icon-color.svg", solid: true }, // U+EA05
	"facebook-groups": { label: "Facebook Groups", brand: "#257CE1", color: null, mark: null, solid: true }, // U+EA06
	"google-business": { label: "Google Business Profile", brand: "#437edc", color: "svg-outputs/google-business-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/google-icon-color.svg", solid: true }, // U+EA07
	"instagram": { label: "Instagram", brand: "#D6249F", color: "svg-outputs/instagram-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/instagram-icon-color.svg", solid: true }, // U+EA1C
	"linkedin": { label: "LinkedIn", brand: "#0077B5", color: "svg-outputs/linkedin-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/linkedin-icon-color.svg", solid: true }, // U+EA08
	"mastodon": { label: "Mastodon", brand: "#563ACC", color: "svg-outputs/mastodon-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/mastodon-icon-color.svg", solid: true }, // U+EA09
	"nextdoor": { label: "Nextdoor", brand: "#0081CA", color: "svg-outputs/nextdoor-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/nextdoor-icon-color.svg", solid: true }, // U+EA0A
	"pinterest": { label: "Pinterest", brand: "#bd081c", color: "svg-outputs/pinterest-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/pinterest-icon-color.svg", solid: true }, // U+EA0B
	"reddit": { label: "Reddit", brand: "#FF4500", color: "svg-outputs/reddit-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/reddit-icon-color.svg", solid: true }, // U+EA0C
	"rss": { label: "Feed", brand: "#F68F3E", color: "svg-outputs/rss-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/rss-icon-color.svg", solid: true }, // U+EA0D
	"shopify": { label: "Shopify", brand: "#96BE4E", color: "svg-logos/shopify-color.svg", mark: null, solid: true }, // U+EA0E
	"slack": { label: "Slack", brand: "#8dd2b8", color: "svg-outputs/slack-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/slack-icon-color.svg", solid: true }, // U+EA0F
	"snapchat": { label: "Snapchat", brand: "#EBE805", color: "svg-outputs/snapchat-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/snapchat-icon-color.svg", solid: true }, // U+EA10
	"stocktwits": { label: "StockTwits", brand: "#40576f", color: "svg-outputs/stocktwits-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/stocktwits-icon-color.svg", solid: true }, // U+EA11
	"substack": { label: "Substack", brand: "#ff7731", color: "svg-logos/substack-color.svg", mark: null, solid: true }, // U+EA12
	"threads": { label: "Threads", brand: "#000000", color: "svg-outputs/threads-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/threads-icon-color.svg", solid: true }, // U+EA13
	"tiktok": { label: "TikTok", brand: "#000000", color: "svg-outputs/tiktok-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/tiktok-icon-color.svg", solid: true }, // U+EA14
	"tumblr": { label: "Tumblr", brand: "#35465c", color: "svg-outputs/tumblr-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/tumblr-icon-color.svg", solid: true }, // U+EA15
	"unsplash": { label: "Unsplash", brand: "#000000", color: null, mark: null, solid: true }, // U+EA16
	"vimeo": { label: "Vimeo", brand: "#1ab7ea", color: "svg-logos/vimeo.svg", mark: null, solid: true }, // U+EA17
	"wordpress": { label: "WordPress", brand: "#21759B", color: "svg-outputs/wordpress-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/wordpress-icon-color.svg", solid: true }, // U+EA18
	"x": { label: "X", brand: "#000000", color: "svg-outputs/x-twitter-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/x-icon-color.svg", solid: true }, // U+EA19
	"youtube": { label: "YouTube", brand: "#ff0000", color: "svg-outputs/youtube-dlvrit-social-output.svg", mark: "network-icons-svg/network-icons-color/youtube-icon-color.svg", solid: true }, // U+EA1A
};

export const NETWORK_SLUGS = Object.keys(NETWORKS).sort() as readonly NetworkSlug[];

/**
 * Default asset host. Production swaps this for the CDN — pass
 * "https://static.dlvrit.com/dist/img" as <Networks assetBaseUrl>.
 */
export const DEFAULT_NETWORK_ASSET_BASE = "/images";

export function isNetworkSlug(value: string): value is NetworkSlug {
	return Object.prototype.hasOwnProperty.call(NETWORKS, value);
}
